export default function () {
	document.addEventListener('DOMContentLoaded', function () {
		var elems = document.querySelectorAll('.sidenav');
		var instances = M.Sidenav.init(elems);

		var elems1 = document.querySelectorAll('select');
		var instances1 = M.FormSelect.init(elems1);

		var elems = document.querySelectorAll('.materialboxed');
		var instances = M.Materialbox.init(elems, {});
	});
};



// WEBPACK FOOTER //
// ./src/assets/js/materialize.js